module.exports = "<div class=\"alert-success\">\n  <div>\n    <img src=\"assets/tick-default.svg\" />\n  </div>\n</div>\n"